module.exports = __webpack_public_path__ + "img/box1.e5c88fc6.png";